<template>
  <div v-if="show" class="popupView" :style="bodyStyle">
    <div class="van-overlay" :style="{zIndex:getMaxZIndex()}" />
    <div class="van-popup" :style="{height:height,zIndex:getMaxZIndex()}">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupView',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '100vh'
    },
    bodyStyle: {
      type: Object,
      default: () => { return {} }
    }
  },
  methods: {
    getMaxZIndex() {
      const arr = [...document.all].map(e => +window.getComputedStyle(e).zIndex || 0)
      return arr.length ? Math.max(...arr) + 1 : 0
    },
    onClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.van-overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2005;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
}

.van-popup {
  position: fixed;
  z-index: 2006;
  max-height: 100%;
  overflow-y: auto;
  background-color: #fff;
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  -webkit-overflow-scrolling: touch;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>
